import React from "react";
import { useTranslate } from "../i18n";

export default function PageFallback() {
  const { t } = useTranslate();

  return (
    <div
      style={{
        minHeight: 240,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--muted2)",
        fontSize: 13,
        fontWeight: 600,
      }}
    >
      {t("layout.loading")}
    </div>
  );
}
